/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_Trend_WorseningInputs */

const en_us2_profile_editors_pain_trend_worsening = /** @type {(inputs: Profile_Editors_Pain_Trend_WorseningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getting worse`)
};

const pt_br2_profile_editors_pain_trend_worsening = /** @type {(inputs: Profile_Editors_Pain_Trend_WorseningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piorando`)
};

const es_419_profile_editors_pain_trend_worsening = /** @type {(inputs: Profile_Editors_Pain_Trend_WorseningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empeorando`)
};

const pt_pt2_profile_editors_pain_trend_worsening = /** @type {(inputs: Profile_Editors_Pain_Trend_WorseningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A piorar`)
};

const fr_fr2_profile_editors_pain_trend_worsening = /** @type {(inputs: Profile_Editors_Pain_Trend_WorseningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ça empire`)
};

const de_de2_profile_editors_pain_trend_worsening = /** @type {(inputs: Profile_Editors_Pain_Trend_WorseningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird schlimmer`)
};

const it_it2_profile_editors_pain_trend_worsening = /** @type {(inputs: Profile_Editors_Pain_Trend_WorseningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peggiora`)
};

/**
* | output |
* | --- |
* | "Getting worse" |
*
* @param {Profile_Editors_Pain_Trend_WorseningInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_trend_worsening = /** @type {((inputs?: Profile_Editors_Pain_Trend_WorseningInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_Trend_WorseningInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_trend_worsening(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_trend_worsening(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_trend_worsening(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_trend_worsening(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_trend_worsening(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_trend_worsening(inputs)
	return en_us2_profile_editors_pain_trend_worsening(inputs)
});
export { profile_editors_pain_trend_worsening as "profile-editors.pain_trend_worsening" }